import { useCallback } from "react";

import {
    useCustomerIdentityAttrs,
    useFireAnalyticsEvents
} from "@/components/fastshift/analytics";
import {
    SourceKey,
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/components/fastshift/analytics/constants";

import { CustomerDomainJiraBoardEmbedType } from "../jira-embedded-board-section/types";

export const useMigrationsManagementUIAnalytics = () => {
    const identityAttrs = useCustomerIdentityAttrs(true);
    const { fireUIEvent } = useFireAnalyticsEvents(identityAttrs);

    // UI event callbacks
    const sendEmbedViewToggleUIEvent = useCallback(
        (selectedEmbedType: CustomerDomainJiraBoardEmbedType) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.BUTTON,
                actionSubjectId:
                    ActionSubjectIdKey.EMBED_VIEW_TYPE_TOGGLE_BUTTON,
                source: SourceKey.FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN,
                attributes: {
                    selectedEmbedType
                }
            });
        },
        [fireUIEvent]
    );

    const sendBoardSelectionUIEvent = useCallback(
        (selectedProjectKey: string, selectedBoardId: string) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.BUTTON,
                actionSubjectId: ActionSubjectIdKey.SELECT_BOARD_DROPDOWN_ITEM,
                source: SourceKey.FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN,
                attributes: {
                    selectedProjectKey,
                    selectedBoardId
                }
            });
        },
        [fireUIEvent]
    );

    const sendJiraEmbedLinkClickUIEvent = useCallback(
        (
            engagementUrl: string,
            selectedEmbedType: CustomerDomainJiraBoardEmbedType
        ) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.LINK,
                actionSubjectId: ActionSubjectIdKey.JIRA_EMBED_LINK,
                source: SourceKey.FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN,
                attributes: {
                    engagementUrl,
                    selectedEmbedType
                }
            });
        },
        [fireUIEvent]
    );

    return {
        sendEmbedViewToggleUIEvent,
        sendBoardSelectionUIEvent,
        sendJiraEmbedLinkClickUIEvent
    };
};
